module.exports = __webpack_public_path__ + "img/trial3-3.21e5038e.png";